export default __webpack_public_path__ + "static/media/stone_shake.8bc727d9.mp3";